import { search } from "../../../../BaseRepositoryComponents";

const path = `${process.env.REACT_APP_URL_API_ERP}/erp/prouser/parceiroscomerciais/v1`;
const token = process.env.REACT_APP_TOKEN_API_ERP;

const headers = new Headers();
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export async function findParceirosComerciais({
  empresa_cnpj,
  per_page = 1000,
  where = {},
  orwhere = {},
}) {
  let queryWhere = "";
  Object.keys(where).forEach((key) => {
    queryWhere += `&where[${key}]=${where[key]}`;
  });
  let queryOrWhere = "";
  Object.keys(orwhere).forEach((key) => {
    queryOrWhere += `&orwhere[${key}]=${orwhere[key]}`;
  });

  return search(
    `${path}?empresa_cnpj=${empresa_cnpj}${queryWhere}${queryOrWhere}${
      per_page && `&per_page=${per_page}`
    }`,
    "GET",
    headers
  );
}
